module.exports = __webpack_public_path__ + "static/img/兰州银行@2x.5a7074ff.png";